import React, { useEffect, useRef, useState } from "react";
import { Tabs, Modal, Form, Input, Switch, Alert, Button, Space, Tag, Drawer, Dropdown } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { ApiTwoTone } from "@ant-design/icons";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import useMessage from "antd/es/message/useMessage";
import { UserService } from "../../../../Services/Manage/UserService";
import CreateUB from "./CreateUB";
import AddSingleExpense from "./AddSingleExpense";
import BtnGroup from "./BtnGroup";

const UbType = ({ onUbTypeChange, getAllExpense }) => {
    const [activeKey, setActiveKey] = useState(null);
    const [items, setItems] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editId, setEditId] = useState(null);

    const [form] = Form.useForm();
    const newTabIndex = useRef(0);
    const [messageApi, msgContext] = useMessage();
    const { confirm } = Modal;

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerContent, setDrawerContent] = useState(null);


    const getAllUbType = async () => {
        try {
            const result = await ExpenseServices.getAllUBtype();

            const list = result.data.map((item) => ({
                key: String(item.id),
                id: item.id,
                billType: item.type,
                description: item.description,
                status: item.status,
            }));

            setItems(list);

            if (list.length > 0) {
                setActiveKey(list[0].key);

                if (onUbTypeChange) onUbTypeChange(list[0]);
            }
        } catch (err) {
            console.error(err);
        }
    };



    useEffect(() => {
        getAllUbType();
    }, []);

    const onChange = (newActiveKey) => {
        setActiveKey(newActiveKey);

        const selected = items.find((i) => i.key === newActiveKey);
        if (onUbTypeChange) onUbTypeChange(selected);
    };


    /** DELETE TAB */
    const deleteTab = (key) => {
        const tab = items.find((t) => t.key === key);

        confirm({
            title: "Are you sure you want to delete this?",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            async onOk() {
                try {
                    if (tab?.id) {
                        await ExpenseServices.deleteUBtype(tab.id);
                        messageApi.success("Deleted successfully");
                        getAllUbType();
                    }

                    const updated = items.filter((t) => t.key !== key);
                    setItems(updated);
                    getAllUbType();
                    if (updated.length > 0) setActiveKey(updated[0].key);

                } catch (error) {
                    console.error(error);
                    messageApi.error("Failed to delete");
                    getAllUbType();
                }
            },
        });
    };

    /** OPEN CREATE MODAL */
    const openAddModal = () => {
        setEditId(null);
        form.resetFields();
        setIsModalOpen(true);
    };

    /** OPEN EDIT MODAL */
    const openEditModal = (key) => {
        const tab = items.find((t) => t.key === key);
        setEditId(tab.id);

        form.setFieldsValue({
            billType: tab.billType,
            description: tab.description,
            status: tab.status,
        });

        setIsModalOpen(true);
    };

    /** SUBMIT FORM (CREATE OR UPDATE) */
    const handleSubmit = async () => {
        const user = await UserService.getOmeUser();

        form.validateFields().then(async (values) => {
            const { billType, description, status } = values;

            const ub_type = {
                type: billType,
                description,
                status,
                added_by: user.uid,
            };

            if (editId) {

                console.log(editId);

                try {
                    const response = await ExpenseServices.updateUBtype(ub_type, editId);

                    if (response.status) {
                        const updated = items.map((item) =>
                            item.id === editId
                                ? {
                                    ...item,
                                    billType,
                                    description,
                                    status,
                                }
                                : item
                        );

                        setItems(updated);
                        setIsModalOpen(false);
                        messageApi.success(response.message);
                    } else {
                        messageApi.error(response.message);
                    }
                } catch (err) {
                    console.error(err);
                }
                return;
            }
            try {
                const response = await ExpenseServices.createUBtype(ub_type);

                if (response.status) {
                    const newId = response.data.id;

                    const newItem = {
                        key: String(newId),
                        id: newId,
                        billType,
                        description,
                        status,
                    };

                    setItems([...items, newItem]);
                    setActiveKey(String(newId));

                    // 🔥 ADD THIS
                    if (onUbTypeChange) {
                        onUbTypeChange(newItem);
                    }

                    form.resetFields();
                    setIsModalOpen(false);
                    getAllUbType();
                    messageApi.success(response.message);
                } else {
                    messageApi.error(response.message);
                    getAllUbType();
                }
            } catch (err) {
                console.error(err);
            }
        });
    };

    /** ALERT CONTENT WITH EDIT + DELETE BUTTONS INSIDE ALERT */
    const tabContent = (tab) => (
        <div style={{ position: "relative" }}>
            <Space
                style={{
                    position: "absolute",
                    right: 10,
                    top: 10,
                    zIndex: 10,
                }}
            >
                {tab.status ? (
                    <Tag size="large" style={{ fontSize: 16, padding: "6px 14px" }}>
                        Active
                    </Tag>
                ) : (
                    <Tag size="large" style={{ fontSize: 16, padding: "6px 14px" }}>
                        Inactive
                    </Tag>
                )}

                <Button
                    size="large"
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => openEditModal(tab.key)}
                >
                    Edit
                </Button>
                <Button
                    size="large"
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => deleteTab(tab.key)}
                >
                    Delete
                </Button>
            </Space>

            <Alert
                message={<b>{tab.billType}</b>}
                description={<p><b>Description:</b> {tab.description}</p>}
                type={tab.status ? "success" : "error"}
                showIcon
                icon={!tab.status ? <ApiTwoTone /> : undefined}
            />
        </div>
    );

    return (
        <>
            {msgContext}

            <Tabs
                size="large"
                type="card"
                activeKey={activeKey}
                onChange={onChange}
                items={items.map((t) => ({
                    key: t.key,
                    label: t.billType,
                    children: tabContent(t),
                }))}
                tabBarExtraContent={
                    <Space>

                        <Button type="primary" onClick={openAddModal} size="large">
                            <PlusOutlined style={{ marginRight: 6 }} />
                            Create New Bill Type
                        </Button>


                        <BtnGroup openAddModal={openAddModal}
                            setDrawerContent={setDrawerContent}
                            setDrawerOpen={setDrawerOpen} />
                    </Space>
                }
            />

            {/* <Space style={{ padding: "20px 0 20px 0" }}>
                <Button
                    size="large"
                    onClick={() => {
                        setDrawerContent("single");
                        setDrawerOpen(true);
                    }}
                >
                    Add Expense
                </Button>

                <Button
                    size="large"
                    onClick={() => {
                        setDrawerContent("bulk");
                        setDrawerOpen(true);
                    }}
                >
                    Add Bulk Expense
                </Button>
            </Space> */}


            <Modal
                title={editId ? "Update Bill Type" : "Create New Bill Type"}
                open={isModalOpen}
                onOk={handleSubmit}
                onCancel={() => setIsModalOpen(false)}
                okText={editId ? "Update" : "Create"}
            >
                <Form form={form} layout="vertical" component={false}>

                    <Form.Item
                        label="Bill Type"
                        name="billType"
                        rules={[{ required: true, message: "Please enter bill type" }]}
                    >
                        <Input size="large" placeholder="Enter bill type" />
                    </Form.Item>

                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[{ required: true, message: "Please enter description" }]}
                    >
                        <Input.TextArea size="large" rows={4} placeholder="Enter description" />
                    </Form.Item>

                    <Form.Item label="Status" name="status" valuePropName="checked">
                        <Switch size="large" checkedChildren="Active" unCheckedChildren="Inactive" />
                    </Form.Item>
                </Form>
            </Modal>

            <Drawer
                width={1350}
                title={drawerContent === "single" ? "Add Expense" : "Add Bulk Expense"}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                {drawerContent === "single" && (
                    <AddSingleExpense activeBillType={activeKey} getAllExpense={getAllExpense} onClose={() => setDrawerOpen(false)} />
                )}

                {drawerContent === "bulk" && (
                    <CreateUB activeBillType={activeKey} getAllExpense={getAllExpense} onClose={() => setDrawerOpen(false)} />
                )}
            </Drawer>

        </>
    );
};

export default UbType;
